import { Record } from 'immutable';

export default Record({
    manufacturerRebates: 0,
    governmentRebates: 0,
    dealerRebates: 0,
    total: 0,
    electricRebateIncluded: false,
});



// WEBPACK FOOTER //
// ./src/models/Incentives.js